import { render, staticRenderFns } from "./positioningdevicefitting-change-installer-modal.vue?vue&type=template&id=2b1fbf1a"
import script from "./positioningdevicefitting-change-installer-modal.vue?vue&type=script&lang=js"
export * from "./positioningdevicefitting-change-installer-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports